import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Vuesax from 'vuesax'

import 'vuesax/dist/vuesax.css'

Vue.config.productionTip = false

Vue.use(Vuesax, {
  colors: {
    primary: '#ddd'
  }
})

Vue.directive('scroll', {
  inserted: (el, binding) => {
    let f = (evt) => {
      if (binding.value(evt, el)) {
        window.removeEventListener('scroll', f);
      }
    };
    window.addEventListener('scroll', f);
  },
});

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
